import React from 'react';
import './Homepage.css';
import logo from '../../assets/logo-agroinsider.svg';
import logo_footer from '../../assets/logos_footer.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Importando useTranslation
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

function Homepage() {
  const { t } = useTranslation(); // Usando useTranslation para acessar as traduções
  const navigate = useNavigate(); // Para navegação programática
  // Função para redirecionar ao clicar no botão
  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="home background-image">
      <div className="content">
        <div className="content-logo-agroinsider">
          <img src={logo} alt="AgroInsider Logo" className="logo" />
          <span className='card-title'>{t('homepage_carbon_title_logo')}</span>
          <span className='card-description' style={{textAlign: "left"}}>{t('homepage_carbon_description_logo1')}<br/>{t('homepage_carbon_description_logo2')}</span>
          <span className='card-description'></span>
        </div>
        <div className='homepage-cards'>
          <div className='homepage-card measure'>
            <span className='card-title'>{t('homepage_carbon_title1')}</span>
            <span className='card-description'>{t('homepage_carbon_description1')}</span>
            <button className="form-next-button" onClick={() => handleNavigate('/general-information')}>{t('calculate_carbon_footprint')}</button>
          </div>
          <div className='homepage-card learn'>
            <span className='card-title'>{t('homepage_carbon_title2')}</span>
            <span className='card-description'>{t('homepage_carbon_description2')}</span>
            <button className="form-next-button" onClick={() => handleNavigate('/know-more')}>{t('find_more')}</button>
          </div>
          <div className='homepage-card improve'>
            <span className='card-title'>{t('homepage_carbon_title3')}</span>
            <span className='card-description'>{t('homepage_carbon_description3')}</span>
            <button className="form-next-button" onClick={() => handleNavigate('/carbon-improvement')}>{t('find_more')}</button>
          </div>
        </div>
        <LanguageSwitcher />
        <div>
          <img src={logo_footer} alt="AgroInsider Logo" className="logo" />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
